// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VbPot","name":"styles_name__3hgE6","phone":"styles_phone__2t0kw"};